<div class="wrapper">
  <div class="content-wrapper">
    <div class="spacecls"></div>

    <div class="col-md-12 ">
      <nav aria-label="breadcrumb">
        <ol class="breadcrumb breadcrumb_dashboard">
          <li>
            <span class="fontnormal"><img src="assets/images/home_india.svg" class="home_india"></span>
          </li>
          <ng-container *ngIf="breadCrumbArr.length == 0">
            <li class="breadcrumb-item"> India</li>
          </ng-container>
          <li *ngFor="let b of breadCrumbArr; let isLast=last;"
            class="breadcrumb-item"
            [ngClass]="{'active' : isLast}"
            >
            <a *ngIf="!isLast" (click)="headerTextLbl= b.type;nextLevel(b.type, state_id, district_id)">{{b.name}}</a>
            <a *ngIf="isLast">{{b.name}}</a>
          </li>
        </ol>
      </nav>
    </div>

    <section class="content">
      <div class="container-fluid main-card-block">
        <div class="row">
          <div class="col-lg-4 cardblockcls col-6 margin-b">
            <div class="small-box bg-white dash-box cm-site-conduct-box">
              <div class="icon">
                <img
                  src="assets/images/building.png"
                  alt="sites"
                  class="img-fluid img_icon"
                />
              </div>
              <div class="inner innerbox">
                <p class="fontnormal titlemob">Total Vaccinated</p>
                <h3>
                  <span class="fontnormal cls_today"></span
                  >{{ this.vaccinationData?.vaccination?.total | numberFormat }}
                </h3>

                <div class="row m-0 r-0 w-100 csutomcsls cm-t-registration">
                  <div class="col pr-0">
                    <small class="text-muted txt_male">Male</small>
                    <p class="d-block mb-0 font-weight-bold font-2 p_male">
                      {{
                        this.vaccinationData?.vaccination?.male
                          | numberFormat
                      }}
                    </p>
                  </div>
                  <div class="col pr-0">
                    <small class="text-muted">Female</small>
                    <p class="d-block mb-0 font-weight-bold font-2">
                      {{
                        this.vaccinationData?.vaccination?.female
                          | numberFormat
                      }}
                    </p>
                  </div>
                  <div class="col pr-0">
                    <small class="text-muted">Others</small>
                    <p class="d-block mb-0 font-weight-bold font-2">
                      {{
                        this.vaccinationData?.vaccination?.others
                          | numberFormat
                      }}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-lg-4 cardblockcls col-6 margin-b">
            <div class="small-box bg-white cm-planned-vac-box">
              <div class="icon icon-bg-session">
                <span class="icon-session"></span>
              </div>
              <div class="inner innerbox">
                <p class="fontnormal titlemob">Vaccination Centers</p>
                <h3>
                  <span class="fontnormal cls_today"></span
                  >{{ vaccinationData?.sites?.total | numberFormat }}
                </h3>

                <div class="row m-0 r-0 w-100 csutomcsls cm-t-registration">
                  <div class="col pr-0">
                    <small class="text-muted txt_male">Government</small>
                    <p class="d-block mb-0 font-weight-bold font-2 p_male">
                      {{ vaccinationData?.sites?.govt | numberFormat }}
                    </p>
                  </div>
                  <div class="col pr-0">
                    <small class="text-muted">Private</small>
                    <p class="d-block mb-0 font-weight-bold font-2">
                      {{ vaccinationData?.sites?.pvt | numberFormat }}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-lg-4 cardblockcls col-6 margin-b">
            <div class="small-box bg-white dash-box cm-site-conduct-box">
              <div class="icon">
                <img
                  src="assets/images/building.png"
                  alt="sites"
                  class="img-fluid img_icon"
                />
              </div>
              <div class="inner innerbox">
                <p class="fontnormal titlemob">Vaccination Doses Administered</p>
                <h3>
                  <span class="fontnormal cls_today"></span
                  >{{
                    vaccinationData?.vaccination?.total_doses | numberFormat
                  }}
                </h3>

                <div class="row m-0 r-0 w-100">
                  <div class="col pl-0">
                    <small class="text-muted">Dose 1</small>
                    <p class="d-block mb-0 font-weight-bold font-2">
                      {{
                        vaccinationData?.vaccination?.tot_dose_1 | numberFormat
                      }}
                    </p>
                  </div>
                  <div class="col pr-0">
                    <small class="text-muted">Dose 2</small>
                    <p class="d-block mb-0 font-weight-bold font-2">
                      {{
                        vaccinationData?.vaccination?.tot_dose_2 | numberFormat
                      }}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <section class="col-lg-6 connectedSortable">
            <div class="card">
              <div class="card-header">
                <h3 class="card-title blocktitle">Vaccination Trend - {{todaysdate | date: 'dd/MM/yyyy'}}</h3>
                <div class="card-tools">
                  <button
                    type="button"
                    class="btn btn-tool"
                    data-card-widget="collapse"
                  >
                    <i class="fas fa-minus"></i>
                  </button>
                  <button
                    type="button"
                    class="btn btn-tool"
                    data-card-widget="remove"
                  >
                    <i class="fas fa-times"></i>
                  </button>
                </div>
              </div>
              <div class="card-body">
                <canvas
                  *ngIf="!deviceService.isMobile(); else mobileVaccTrendCNVS"
                  id="vaccination-trends"
                  width="600"
                  height="241"
                ></canvas>
                <ng-template #mobileVaccTrendCNVS>
                  <canvas id="vaccination-trends" width="600" height="600"></canvas>
                </ng-template>
              </div>
            </div>
          </section>

          <section class="col-lg-6 connectedSortable">
            <div class="card">
              <div class="card-header">
                <h3 class="card-title blocktitle">
                  Vaccination Trend (Last 7 Days)
                </h3>
                <div class="card-tools">
                  <button
                    type="button"
                    class="btn btn-tool"
                    data-card-widget="collapse"
                  >
                    <i class="fas fa-minus"></i>
                  </button>
                  <button
                    type="button"
                    class="btn btn-tool"
                    data-card-widget="remove"
                  >
                    <i class="fas fa-times"></i>
                  </button>
                </div>
              </div>
              <div class="card-body">
                <canvas *ngIf="!deviceService.isMobile() else mobileVaccTrendLast7days"  id="vaccination-trends-seven-days" width="600" height="240"></canvas>
                  <ng-template #mobileVaccTrendLast7days>
                    <canvas id="vaccination-trends-seven-days" width="600" height="400"></canvas>
                  </ng-template>
                </div>
            </div>
          </section>
        </div>
        <div class="row">
          <section class="col-lg-6 connectedSortable">
            <div class="card">
              <div class="card-header">
                <h3 class="card-title blocktitle">Vaccination by Age
                  <span class="reg_tooltip" tooltip="Includes All FLW, HCW & General Citizens" placement="bottom">
                    <img class="infoicon" src="assets/images/info_icon.svg">
                    </span>
                </h3>
                <div class="card-tools">
                  <button
                    type="button"
                    class="btn btn-tool"
                    data-card-widget="collapse"
                  >
                    <i class="fas fa-minus"></i>
                  </button>
                  <button
                    type="button"
                    class="btn btn-tool"
                    data-card-widget="remove"
                  >
                    <i class="fas fa-times"></i>
                  </button>
                </div>
              </div>
              <div class="card-body">
                <canvas *ngIf="!deviceService.isMobile() else vaccByAgeCanvas"  id='vaccination-by-age' width="300" height="133"></canvas>
                <ng-template #vaccByAgeCanvas>
                      <canvas id="vaccination-by-age" width="600" height="400"></canvas>
                </ng-template>
              </div>
            </div>
          </section>
          <section class="col-lg-6 connectedSortable">
            <div class="card">
              <div class="card-header">
                <h3 class="card-title blocktitle">Vaccination Coverage</h3>
                <div class="card-tools">
                  <button
                    type="button"
                    class="btn btn-tool"
                    data-card-widget="collapse"
                  >
                    <i class="fas fa-minus"></i>
                  </button>
                  <button
                    type="button"
                    class="btn btn-tool"
                    data-card-widget="remove"
                  >
                    <i class="fas fa-times"></i>
                  </button>
                </div>
              </div>
              <div class="card-body">
                <canvas *ngIf="!deviceService.isMobile() else vaccCoverageByStateCanvas"  id='vaccination-coverage-by-state' width="300" height="133"></canvas>
                <ng-template #vaccCoverageByStateCanvas>
                      <canvas id="vaccination-coverage-by-state" width="600" height="400"></canvas>
                </ng-template>
              </div>
            </div>
          </section>
        </div>
        <div class="row">
          <section class="col-lg-6 connectedSortable">
            <div class="card">
              <div class="card-header">
                <h3 class="card-title blocktitle">AEFI Reported</h3>
                <span style="float:right;font-weight: bold;">Overall : {{ vaccinatedAefiPer }} %</span>
                <div class="card-tools">
                  <button
                    type="button"
                    class="btn btn-tool"
                    data-card-widget="collapse"
                  >
                    <i class="fas fa-minus"></i>
                  </button>
                  <button
                    type="button"
                    class="btn btn-tool"
                    data-card-widget="remove"
                  >
                    <i class="fas fa-times"></i>
                  </button>
                </div>
              </div>
              <div class="card-body">

                <canvas *ngIf="!deviceService.isMobile() else mobileVaccAefiLast7days"  id="vaccination-aefi-seven-days" width="600" height="240"></canvas>
                  <ng-template #mobileVaccAefiLast7days>
                    <canvas id="vaccination-aefi-seven-days" width="600" height="400"></canvas>
                  </ng-template>
              </div>
            </div>
          </section>

          <section class="col-lg-6 connectedSortable">
            <div class="card">
              <div class="card-header">
                <h3 class="card-title blocktitle">Vaccination by Brand</h3>
                <div class="card-tools">
                  <button
                    type="button"
                    class="btn btn-tool"
                    data-card-widget="collapse"
                  >
                    <i class="fas fa-minus"></i>
                  </button>
                  <button
                    type="button"
                    class="btn btn-tool"
                    data-card-widget="remove"
                  >
                    <i class="fas fa-times"></i>
                  </button>
                </div>
              </div>
              <div class="card-body">
                <canvas *ngIf="!deviceService.isMobile() else mobileVaccBrandLast7days"  id="vaccination-brand-seven-days" width="600" height="240"></canvas>
                  <ng-template #mobileVaccBrandLast7days>
                    <canvas id="vaccination-brand-seven-days" width="600" height="400"></canvas>
                  </ng-template>
              </div>
            </div>
          </section>
        </div>
      </div>
    </section>
  </div>
</div>
